import React from 'react'

function Addressfile() {
  return (
    <div>   <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 3.83333V13.086C14 13.8667 13.3667 14.5 12.586 14.5H3.414C2.63333 14.5 2 13.8667 2 13.086V3.914C2 3.13333 2.63333 2.5 3.414 2.5H12.6667C13.4033 2.5 14 3.09667 14 3.83333Z"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66634 2.5V14.5"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33402 9.84311C8.78135 9.84311 8.33402 9.39511 8.33402 8.84311C8.33402 8.29111 8.78202 7.84311 9.33402 7.84311V7.84311C9.88668 7.84311 10.334 8.29111 10.334 8.84311V9.28711C10.334 9.74645 10.7073 10.1204 11.1673 10.1204C11.6273 10.1204 12.0007 9.74778 12.0007 9.28711V8.84311C12.0007 7.37045 10.8067 6.17578 9.33335 6.17578C7.86002 6.17578 6.66602 7.36978 6.66602 8.84245C6.66602 10.3151 7.86002 11.5098 9.33268 11.5098C9.67335 11.5098 10.0193 11.4451 10.354 11.3071"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.334 8.84375C10.334 9.39642 9.88598 9.84375 9.33398 9.84375"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Addressfile